import React, { Component } from "react";

import {
  CButton,
  CSpinner,
  CModal,
  CModalFooter,
  CModalBody,
  CModalHeader,
  CDropdown,
  CDropdownMenu,
  CDropdownItem,
  CDropdownToggle
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import URL from "../../config/api";
import axios from "../../config/axios";
import { getShareRoles } from "../../helpers/doc";
import Dropzone from "../Dropzone";

import "react-bootstrap-table/dist//react-bootstrap-table-all.min.css";

class UploadModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // name: "",
      // description: "",
      loading: false,
      selectedRoles: "Todos",
      files: [],
      roles: [],
      docs: []
    };
  }

  componentDidMount() {
    getShareRoles(this.props.general.active_roles, this.props.user.token).then(
      roles => {
        this.setState({
          roles: roles.map(role => ({ ...role, room_id: this.props.room }))
        });
      },
      error => {
        this.error("Erro ao encontrar perfis");
      }
    );
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  upload() {
    if (this.state.files.length < 1) {
      return;
    }

    this.setState({ loading: true });

    const formData = new FormData();

    for (let i = 0; i < this.state.files.length; i++) {
      formData.append(`file${i}`, this.state.files[i]);
    }

    let { roles } = this.state;

    if (this.state.selectedRoles === "Apenas eu") {
      roles = [];
    } else if (this.state.selectedRoles !== "Todos") {
      roles = roles.filter(item => item.role_name === this.state.selectedRoles);
    }

    axios
      .post(
        `${URL.api}file/room-${this.props.room}/${this.props.user.user.id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${this.props.user.token}`
          }
        }
      )
      .then(
        resp => {
          const arr = [];
          const len = resp.data.files.length;
          resp.data.files.forEach(file => {
            axios
              .post(
                `${URL.api}content/doc/insert`,
                {
                  doc_id: this.props.doc_id,
                  folder: false,
                  name: file.original,
                  user_id: this.props.user.user.id,
                  room_id: this.props.room,
                  type_id: 17,
                  size: file.size,
                  link: URL.public + file.url,
                  role: roles
                },
                {
                  headers: { Authorization: `Bearer ${this.props.user.token}` }
                }
              )
              .then(
                resp => {
                  arr.push(resp.data.data);

                  if (arr.length === len) {
                    this.insertNotice(arr);
                  }
                },
                error => {
                  this.error(error.response.statusText);
                }
              );
          });
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  insertNotice(docs) {
    this.setState({ loading: true });

    let { roles } = this.state;

    if (this.state.selectedRoles === "Apenas eu") {
      roles = [];
    } else if (!this.state.selectedRoles === "Todos") {
      roles = roles.find(item => item.role_name === this.state.selectedRoles);
    }

    const obj = {
      user_id: this.props.user.user.id,
      title:
        this.state.docs.length > 1
          ? "Novos arquivos compartilhados"
          : "Novo arquivo compartilhado",
      description:
        this.state.docs.length > 1
          ? "Visite a aba de documentos para vê-los."
          : "Visite a aba de documentos para vê-lo.",
      type: "notification",
      docs,
      roles
    };

    axios
      .post(`${URL.api}communication/notice/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState({ loading: false });
          this.props.onClose();
        },
        error => {
          this.error(error.response.statusText);
          this.setState({ loading: false });
        }
      );
  }

  onDrop(files) {
    this.setState({ files });
  }

  render() {
    return (
      <CModal
        size="md"
        centered
        show
        onClose={() => this.props.onClose()}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>Upload de arquivos</CModalHeader>
        <CModalBody>
          <Dropzone onDrop={e => this.onDrop(e)} />
        </CModalBody>
        <CModalFooter className="d-flex justify-content-between">
          <CDropdown
            className="ml-2"
            style={{ border: "1px solid #d8dbe0", borderRadius: "0.25rem" }}
          >
            <CDropdownToggle>
              <span className="mr-1">
                <i className="fa fa-share-alt mr-1"></i>{" "}
                {this.state.selectedRoles}
              </span>
            </CDropdownToggle>
            <CDropdownMenu>
              <CDropdownItem
                onClick={() =>
                  this.setState(state => ({ selectedRoles: "Todos" }))
                }
                active={this.state.selectedRoles === "Todos"}
              >
                Todos
              </CDropdownItem>
              {this.state.roles.map(role => (
                <CDropdownItem
                  onClick={() =>
                    this.setState({ selectedRoles: role.role_name })
                  }
                  active={this.state.selectedRoles === role.role_name}
                >
                  {role.role_name}
                </CDropdownItem>
              ))}
              <CDropdownItem
                onClick={() => this.setState({ selectedRoles: "Apenas eu" })}
                active={this.state.selectedRoles === "Apenas eu"}
              >
                Apenas eu
              </CDropdownItem>
            </CDropdownMenu>
          </CDropdown>
          <div className="d-flex">
            <CButton
              disabled={this.state.loading}
              color="primary"
              className="d-flex justify-content-center align-items-center mr-2"
              onClick={() => this.upload()}
            >
              <span className={this.state.loading ? "invisible" : ""}>
                Continuar
              </span>
              {this.state.loading && (
                <CSpinner
                  size="sm"
                  color="white"
                  style={{ position: "absolute" }}
                />
              )}
            </CButton>{" "}
            <CButton
              disabled={this.state.loading}
              color="secondary"
              onClick={() => this.props.onClose()}
            >
              Cancelar
            </CButton>
          </div>
        </CModalFooter>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadModal);
